import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngxs/store';
import { JobTypeState } from '../../../store/jobType/job-type-state';
import { NzModalService, NzModalRef } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SparepartsService } from '../../../service/spareparts.service';
import {SpareInfoComponent} from '../spare-info/spare-info.component';
@Component({
  selector: 'app-spare-list',
  templateUrl: './spare-list.component.html',
  styleUrls: ['./spare-list.component.less']
})
export class SpareListComponent implements OnInit {

  @Input() code: any; // code 0 备件只能查看，不能选择 code 1 备件可以查看 也可以被选中
  validateForm: FormGroup;
  spareTypes = [];
  listOfData = [];
  listOfCurrentPageData: Data[] = [];
  startRow: number;
  checked = false;
  indeterminate = false;
  setOfCheckedId = new Set<number>();
  setOfCheckedItem = new Set<Data>();
  // 分页查询条件
  pageIndex: number;
  pageSize: number;
  total = 0;
  loading = true;
  constructor(
    private fb: FormBuilder,
    private store: Store,
    private modalRef: NzModalRef,
    private modal: NzModalService,
    public message: NzMessageService,
    private dataService: SparepartsService
  ) {
    this.startRow = 1;
    this.pageIndex = 1;
    this.pageSize = 10;
  }
  ngOnInit(): void {
    this.validateForm = this.fb.group({ typeId: null, spareName: null });
    this.initTypeTree(this.store.selectSnapshot<any[]>(JobTypeState));
    this.querySpareData(1);
  }

  /**
   * 初始化 备件类型下拉框
   */
  initTypeTree(types: any[]) {
    for (const type of types) {
      const node = {
        title: type.skillName,
        value: type.skillId,
        key: type.skillId,
        isLeaf: true
      };
      if (type.parentId === 0) {
        this.spareTypes.push(node);
      }
    }
  }
  /**
   *   @param flag 1表示点击搜索按钮，2表示翻页
   */
  async querySpareData(flag: number) {
    if (flag === 1) {
      this.pageIndex = 1;
      this.pageSize = 10;
    }
    const result = await this.dataService.querySparePartsData(this.validateForm.value, this.pageIndex, this.pageSize);
    this.loading = false;
    if (result.code !== 200) {
      this.message.create('error', '备件数据查询失败!');
      return;
    } else {
      this.listOfData = result.data.list;
      this.total = result.data.total;
      this.startRow = result.data.startRow;
    }
  }
  submitForm() {
    this.querySpareData(1);
  }

  resetForm() {
    this.validateForm.setValue({ typeId: null, spareName: null });
  }

  onPageIndexChange(pageIndex): void {
    this.pageIndex = pageIndex;
    this.querySpareData(2);
  }
  onAllChecked(checked: boolean): void {
    this.listOfCurrentPageData.forEach(data => this.updateCheckedSet(data, checked));
    this.refreshCheckedStatus();
  }
  refreshCheckedStatus(): void {
    const listOfEnabledData = this.listOfCurrentPageData;
    this.checked = listOfEnabledData.every(data => this.setOfCheckedId.has(data.spNo));
    this.indeterminate = listOfEnabledData.some(data => this.setOfCheckedId.has(data.spNo)) && !this.checked;
  }
  updateCheckedSet(data: Data, checked: boolean): void {
    if (checked) {
      this.setOfCheckedItem.add(data);
      this.setOfCheckedId.add(data.spNo);
    } else {
      this.setOfCheckedItem.delete(data);
      this.setOfCheckedId.delete(data.spNo);
    }
  }
  onItemChecked(data: Data, checked: boolean): void {
    this.updateCheckedSet(data, checked);
    this.refreshCheckedStatus();
  }
  onCurrentPageDataChange(listOfCurrentPageData: Data[]): void {
    this.listOfCurrentPageData = listOfCurrentPageData;
    this.refreshCheckedStatus();
  }

  saveEntryData() {
    if (this.code === 1) {
      if (this.setOfCheckedItem.size > 0) {
        this.modalRef.destroy(this.setOfCheckedItem);
      } else {
        this.modalRef.destroy(null);
      }
    } else {
      this.modalRef.destroy(null);
    }
  }
  cancleEntryData() {
    this.modalRef.destroy(null);
  }
  /**
   * 新增备件信息
   */
  addSpareParts(){
    const modal = this.modal.create({
      nzTitle: '新增备件',
      nzContent: SpareInfoComponent,
      nzStyle: { top: '40px' },
      nzWidth: 800,
      nzMaskClosable: false,
      nzFooter: null,
      nzComponentParams: {
        data: null,
      }
    });
    modal.afterClose.subscribe(
      {
        next: num => {
          if (num === 'success') {
            this.querySpareData(1);
          }
        }
      }
    );
  }
  /**
   * 修改备件
   */
  async editData(spareData: any){
    const modal = this.modal.create({
      nzTitle: '修改备件',
      nzContent: SpareInfoComponent,
      nzStyle: { top: '40px' },
      nzWidth: 800,
      nzMaskClosable: false,
      nzFooter: null,
      nzComponentParams: {
        data: spareData,
      }
    });
    modal.afterClose.subscribe(
      {
        next: num => {
          if (num === 'success') {
            this.querySpareData(1);
          }
        }
      }
    );
  }
  /**
   * 删除备件
   */
  async deleteData(data: any){
    if (data.amount > 0){
      this.message.create('warning', '备件库存不为0,无法删除!');
      return;
    }
    const resultObject = await this.dataService.getStockBySpno(data.spNo);
    if (resultObject !== null){
      this.message.create('error', '存在库存，不能删除!');
      return;
    }
    this.modal.confirm({
      nzTitle: '<i>确认要删除该备件信息?</i>',
      nzOnOk: async () => {
        const result = await this.dataService.deleteSparePartsData(data.spNo);
        this.loading = false;
        if (result.code !== 200) {
          this.message.create('error', '删除备件数据失败!');
          return;
        } else {
          this.message.create('success', '删除备件数据成功!');
          this.querySpareData(1);
        }
      }
    });
  }
}
interface Data {
  spNo: number;
  spName: string;
  tName: string;
  spec: string;
  unit: string;
  purpose: string;
  price: number;
}
